export default "__VITE_ASSET__nSo7uhhE__"